import { render, staticRenderFns } from "./AgTableServerSide.vue?vue&type=template&id=963bd02e&"
import script from "./AgTableServerSide.vue?vue&type=script&lang=js&"
export * from "./AgTableServerSide.vue?vue&type=script&lang=js&"
import style0 from "./AgTableServerSide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports